/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Rtx.Verbum.Api | v1
 * OpenAPI spec version: 1.0.0
 */

import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { useMutation, useQuery } from '@tanstack/react-query'
import { customInstance } from '../../../../core/custom-instance'
import type {
  AuditSearchDto,
  DataEnvelopeOfIEnumerableOfAuditLogDto,
  DataPaginationEnvelopeOfAuditLogDto,
  GetRecentAuditLogsParams,
  GetUserAuditLogsParams,
} from '../model'

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K }
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    })
  }
  return result
}

/**
 * Obtém logs de auditoria recentes
 */
export const getRecentAuditLogs = (
  params?: GetRecentAuditLogsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataPaginationEnvelopeOfAuditLogDto>(
    { url: `/v1/audit/recent`, method: 'GET', params, signal },
    options,
  )
}

export const getGetRecentAuditLogsQueryKey = (params?: GetRecentAuditLogsParams) => {
  return [`/v1/audit/recent`, ...(params ? [params] : [])] as const
}

export const getGetRecentAuditLogsQueryOptions = <
  TData = Awaited<ReturnType<typeof getRecentAuditLogs>>,
  TError = unknown,
>(
  params?: GetRecentAuditLogsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getRecentAuditLogs>>, TError, TData>>
    request?: SecondParameter<typeof customInstance>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetRecentAuditLogsQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getRecentAuditLogs>>> = ({ signal }) =>
    getRecentAuditLogs(params, requestOptions, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getRecentAuditLogs>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRecentAuditLogsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRecentAuditLogs>>
>
export type GetRecentAuditLogsQueryError = unknown

export function useGetRecentAuditLogs<
  TData = Awaited<ReturnType<typeof getRecentAuditLogs>>,
  TError = unknown,
>(
  params: undefined | GetRecentAuditLogsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getRecentAuditLogs>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRecentAuditLogs>>,
          TError,
          Awaited<ReturnType<typeof getRecentAuditLogs>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRecentAuditLogs<
  TData = Awaited<ReturnType<typeof getRecentAuditLogs>>,
  TError = unknown,
>(
  params?: GetRecentAuditLogsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getRecentAuditLogs>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRecentAuditLogs>>,
          TError,
          Awaited<ReturnType<typeof getRecentAuditLogs>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRecentAuditLogs<
  TData = Awaited<ReturnType<typeof getRecentAuditLogs>>,
  TError = unknown,
>(
  params?: GetRecentAuditLogsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getRecentAuditLogs>>, TError, TData>>
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetRecentAuditLogs<
  TData = Awaited<ReturnType<typeof getRecentAuditLogs>>,
  TError = unknown,
>(
  params?: GetRecentAuditLogsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getRecentAuditLogs>>, TError, TData>>
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetRecentAuditLogsQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

/**
 * Obtém histórico de auditoria de uma entidade
 */
export const getEntityAuditLogs = (
  entityType: string,
  entityId: number | string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfIEnumerableOfAuditLogDto>(
    { url: `/v1/audit/entity/${entityType}/${entityId}`, method: 'GET', signal },
    options,
  )
}

export const getGetEntityAuditLogsQueryKey = (entityType: string, entityId: number | string) => {
  return [`/v1/audit/entity/${entityType}/${entityId}`] as const
}

export const getGetEntityAuditLogsQueryOptions = <
  TData = Awaited<ReturnType<typeof getEntityAuditLogs>>,
  TError = unknown,
>(
  entityType: string,
  entityId: number | string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntityAuditLogs>>, TError, TData>>
    request?: SecondParameter<typeof customInstance>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetEntityAuditLogsQueryKey(entityType, entityId)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEntityAuditLogs>>> = ({ signal }) =>
    getEntityAuditLogs(entityType, entityId, requestOptions, signal)

  return {
    queryKey,
    queryFn,
    enabled:
      entityType !== null &&
      entityType !== undefined &&
      entityId !== null &&
      entityId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getEntityAuditLogs>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }
}

export type GetEntityAuditLogsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEntityAuditLogs>>
>
export type GetEntityAuditLogsQueryError = unknown

export function useGetEntityAuditLogs<
  TData = Awaited<ReturnType<typeof getEntityAuditLogs>>,
  TError = unknown,
>(
  entityType: string,
  entityId: number | string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntityAuditLogs>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEntityAuditLogs>>,
          TError,
          Awaited<ReturnType<typeof getEntityAuditLogs>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEntityAuditLogs<
  TData = Awaited<ReturnType<typeof getEntityAuditLogs>>,
  TError = unknown,
>(
  entityType: string,
  entityId: number | string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEntityAuditLogs>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEntityAuditLogs>>,
          TError,
          Awaited<ReturnType<typeof getEntityAuditLogs>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEntityAuditLogs<
  TData = Awaited<ReturnType<typeof getEntityAuditLogs>>,
  TError = unknown,
>(
  entityType: string,
  entityId: number | string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntityAuditLogs>>, TError, TData>>
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetEntityAuditLogs<
  TData = Awaited<ReturnType<typeof getEntityAuditLogs>>,
  TError = unknown,
>(
  entityType: string,
  entityId: number | string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntityAuditLogs>>, TError, TData>>
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetEntityAuditLogsQueryOptions(entityType, entityId, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

/**
 * Obtém ações realizadas por um usuário
 */
export const getUserAuditLogs = (
  userId: string,
  params?: GetUserAuditLogsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataPaginationEnvelopeOfAuditLogDto>(
    { url: `/v1/audit/user/${userId}`, method: 'GET', params, signal },
    options,
  )
}

export const getGetUserAuditLogsQueryKey = (userId: string, params?: GetUserAuditLogsParams) => {
  return [`/v1/audit/user/${userId}`, ...(params ? [params] : [])] as const
}

export const getGetUserAuditLogsQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserAuditLogs>>,
  TError = unknown,
>(
  userId: string,
  params?: GetUserAuditLogsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserAuditLogs>>, TError, TData>>
    request?: SecondParameter<typeof customInstance>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetUserAuditLogsQueryKey(userId, params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserAuditLogs>>> = ({ signal }) =>
    getUserAuditLogs(userId, params, requestOptions, signal)

  return {
    queryKey,
    queryFn,
    enabled: userId !== null && userId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getUserAuditLogs>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }
}

export type GetUserAuditLogsQueryResult = NonNullable<Awaited<ReturnType<typeof getUserAuditLogs>>>
export type GetUserAuditLogsQueryError = unknown

export function useGetUserAuditLogs<
  TData = Awaited<ReturnType<typeof getUserAuditLogs>>,
  TError = unknown,
>(
  userId: string,
  params: undefined | GetUserAuditLogsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserAuditLogs>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserAuditLogs>>,
          TError,
          Awaited<ReturnType<typeof getUserAuditLogs>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserAuditLogs<
  TData = Awaited<ReturnType<typeof getUserAuditLogs>>,
  TError = unknown,
>(
  userId: string,
  params?: GetUserAuditLogsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserAuditLogs>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserAuditLogs>>,
          TError,
          Awaited<ReturnType<typeof getUserAuditLogs>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserAuditLogs<
  TData = Awaited<ReturnType<typeof getUserAuditLogs>>,
  TError = unknown,
>(
  userId: string,
  params?: GetUserAuditLogsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserAuditLogs>>, TError, TData>>
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetUserAuditLogs<
  TData = Awaited<ReturnType<typeof getUserAuditLogs>>,
  TError = unknown,
>(
  userId: string,
  params?: GetUserAuditLogsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserAuditLogs>>, TError, TData>>
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetUserAuditLogsQueryOptions(userId, params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

/**
 * Busca logs de auditoria com filtros
 */
export const searchAuditLogs = (
  auditSearchDto: AuditSearchDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataPaginationEnvelopeOfAuditLogDto>(
    {
      url: `/v1/audit/search`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: auditSearchDto,
      signal,
    },
    options,
  )
}

export const getSearchAuditLogsMutationKey = () => ['searchAuditLogs'] as const

export const getSearchAuditLogsMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof searchAuditLogs>>,
    TError,
    SearchAuditLogsMutationVariables,
    TContext
  >
  request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof searchAuditLogs>>,
  TError,
  SearchAuditLogsMutationVariables,
  TContext
> => {
  const mutationKey = getSearchAuditLogsMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof searchAuditLogs>>,
    SearchAuditLogsMutationVariables
  > = (props) => {
    const { data } = props ?? {}

    return searchAuditLogs(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type SearchAuditLogsMutationResult = NonNullable<Awaited<ReturnType<typeof searchAuditLogs>>>
export type SearchAuditLogsMutationBody = AuditSearchDto
export type SearchAuditLogsMutationError = unknown
export type SearchAuditLogsMutationVariables = { data: AuditSearchDto }

export const useSearchAuditLogs = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof searchAuditLogs>>,
      TError,
      SearchAuditLogsMutationVariables,
      TContext
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof searchAuditLogs>>,
  TError,
  SearchAuditLogsMutationVariables,
  TContext
> => {
  return useMutation(getSearchAuditLogsMutationOptions(options), queryClient)
}
